import { DrawArea, updateMapStateProperty } from '@app/redux/riskMap/riskMapSlice'
import { AnyAction, Dispatch } from '@reduxjs/toolkit'
import mapboxgl from 'mapbox-gl'

export interface UpdateDrawAreasProps {
  drawAreas: DrawArea[]
  dispatch: Dispatch<AnyAction>
}

export function handleUpdateDrawAreas({ drawAreas, dispatch }: UpdateDrawAreasProps) {
  dispatch(updateMapStateProperty({ drawAreas }))
}

// Source/layer IDs must match the ones used by SelectionTool so that activating
// the selection tool after a workspace load tears these down cleanly.
const SOURCE_ID = 'selectionToolSource'
const AREA_LAYER_ID = 'selectionToolAreaLayer'
const LINE_LAYER_ID = 'selectionToolLineLayer'

export function renderSavedDrawAreas(map: mapboxgl.Map, drawAreas: DrawArea[]) {
  if (map.getLayer(AREA_LAYER_ID)) map.removeLayer(AREA_LAYER_ID)
  if (map.getLayer(LINE_LAYER_ID)) map.removeLayer(LINE_LAYER_ID)
  if (map.getSource(SOURCE_ID)) map.removeSource(SOURCE_ID)

  if (!drawAreas.length) return

  map.addSource(SOURCE_ID, {
    type: 'geojson',
    data: { type: 'FeatureCollection', features: drawAreas },
  })
  map.addLayer({
    id: AREA_LAYER_ID,
    type: 'fill',
    source: SOURCE_ID,
    paint: { 'fill-color': '#0B2948', 'fill-opacity': 0.1 },
    filter: ['in', '$type', 'Polygon'],
  })
  map.addLayer({
    id: LINE_LAYER_ID,
    type: 'line',
    source: SOURCE_ID,
    layout: { 'line-cap': 'round', 'line-join': 'round' },
    paint: { 'line-color': '#0B2948', 'line-width': 2.5 },
    filter: ['in', '$type', 'LineString', 'Polygon'],
  })
}
